import config from 'constants/config'
import { initSentryClientSide, sendErrorToSentry, sendMessageToSentry } from '../lib/utils/sentryUtils'
import type { AppStore } from '../store'
import getReportDataFromState from 'reporting/utils/getReportDataFromState'

type SentryMessageLevel = 'fatal' | 'error' | 'warning' | 'log' | 'info' | 'debug'

let _store: AppStore | undefined

export function registerErrorReportStore(store: AppStore) {
  _store = store
}

let Sentry: any
export async function reportClientError(error: unknown, additional: Record<string, any> = {}) {
  if (!config.SENTRY_ID) return Promise.resolve()

  if (!Sentry) {
    Sentry = await import(/* webpackChunkName: "Sentry" */ '@sentry/browser')
    initSentryClientSide(Sentry)
  }

  const { account, meta } = getReportDataFromState(_store?.getState())

  const extras = { ...meta, ...additional }

  if (!config.APP_ENV || config.APP_ENV !== 'production') {
    console.warn('Client error reported:', error, { memberId: account?.memberId }, extras)
  }

  return sendErrorToSentry(error, account, extras)
}

export async function reportClientMessage(
  message: string,
  additional: Record<string, any> = {},
  level: SentryMessageLevel = 'warning',
) {
  if (!config.SENTRY_ID) return Promise.resolve()

  if (!Sentry) {
    Sentry = await import(/* webpackChunkName: "Sentry" */ '@sentry/browser')
    initSentryClientSide(Sentry)
  }

  const { account, meta } = getReportDataFromState(_store?.getState())
  const extras = { ...meta, ...additional }

  if (!config.APP_ENV || config.APP_ENV !== 'production') {
    console.warn(`Client ${level} reported:`, message, { memberId: account?.memberId }, extras)
  }

  return sendMessageToSentry(message, account, extras, level)
}
